import React from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import { MobileExpandableDetailCard, MobileStatusChip } from '../../components/mobile'
import { MOBILE_SECTION_DIVIDER_COLOR } from '../../components/mobile/styles/mobileColors'
import { formatMoney } from '../../helpers/utils'
import { ORDER_STATUS_UI_MAP } from '../constants/orderConstants'

const MOBILE_CARD_DIVIDER_COLOR = MOBILE_SECTION_DIVIDER_COLOR
const MOBILE_CARD_ACCENT = '#597FA9'

const buildOrderStatusUI = (status) => {
  const statusUI = ORDER_STATUS_UI_MAP[status]

  if (statusUI) return statusUI

  return {
    label: String(status || '-').toUpperCase(),
    className: ''
  }
}

const buildOrderSummaryRows = (model, getFormattedDate) => [
  {
    label: 'Fecha',
    value: getFormattedDate(model.created_date),
    valueTitle: getFormattedDate(model.created_date)
  },
  {
    label: 'Cliente',
    value: `${model.client_db_ref} - ${model.client_name}`,
    valueTitle: `${model.client_db_ref} - ${model.client_name}`
  },
  {
    label: 'Monto',
    value: formatMoney(Number(model.order_total)),
    valueTitle: formatMoney(Number(model.order_total))
  }
]

const buildOrderDetailRows = (model) => [
  {
    detailRowKey: `${model.uuid}-salesman`,
    icon: <SupervisorAccountIcon sx={{ fontSize: 20 }} />,
    label: 'Creado por',
    value: `${model.salesman_db_ref} - ${model.salesman_name}`,
    valueTitle: `${model.salesman_db_ref} - ${model.salesman_name}`,
    valueSx: {
      display: 'block',
      wordBreak: 'break-word'
    },
    dividerColor: MOBILE_CARD_DIVIDER_COLOR
  },
  {
    detailRowKey: `${model.uuid}-invoice-total`,
    icon: <ReceiptLongIcon sx={{ fontSize: 20 }} />,
    label: 'Total factura',
    value: model.invoice_total > 0 ? formatMoney(Number(model.invoice_total)) : '-',
    valueTitle: model.invoice_total > 0 ? formatMoney(Number(model.invoice_total)) : undefined,
    boldValue: true,
    dividerColor: MOBILE_CARD_DIVIDER_COLOR
  }
]

const buildOrderFooter = (model) => {
  const statusUI = buildOrderStatusUI(model.order_status)

  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ minWidth: 0 }}>
      <Typography
        variant="caption"
        color="text.secondary"
        component="span"
        sx={{
          flexShrink: 0,
          fontSize: 14,
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: 0.04
        }}
      >
        Estado:
      </Typography>
      <Box sx={{ minWidth: 0 }}>
        <MobileStatusChip
          statusUI={statusUI}
          sx={{
            minWidth: 112,
            '& .MuiChip-label': {
              whiteSpace: 'normal',
              textAlign: 'center'
            }
          }}
        />
      </Box>
    </Stack>
  )
}

const OrderMobileCard = ({ model, getFormattedDate, openOrderInNewTab, expanded, onToggleExpand }) => {
  return (
    <Grid size={{ xs: 12, sm: 6, md: 4 }} sx={{ minWidth: 0, display: 'flex', alignItems: 'stretch' }}>
      <MobileExpandableDetailCard
        code={model.order_db_ref}
        onCodeClick={() => openOrderInNewTab(model.uuid)}
        expanded={expanded}
        onToggleExpand={onToggleExpand}
        summaryRows={buildOrderSummaryRows(model, getFormattedDate)}
        detailRows={buildOrderDetailRows(model)}
        accentColor={MOBILE_CARD_ACCENT}
        codeAccentColor={MOBILE_CARD_ACCENT}
        detailDividerColor={MOBILE_CARD_DIVIDER_COLOR}
        footerContent={buildOrderFooter(model)}
        footerDivider
        footerDividerColor={MOBILE_CARD_DIVIDER_COLOR}
        footerPaddingTop={1.5}
        expandAriaLabel={expanded ? 'Ocultar detalle del pedido' : 'Mostrar detalle del pedido'}
        detailRegionAriaLabel={`Detalle del pedido ${model.order_db_ref}`}
        bodyFontSize={14}
        codeFontSize={14}
        summaryLabelFontSize={14}
        summaryValueFontSize={14}
        detailLabelFontSize={14}
        detailValueFontSize={14}
      />
    </Grid>
  )
}

export default OrderMobileCard
